import { Loader2 } from 'lucide-react';
import { cn } from '../ui/utils';

interface LoadingScreenProps {
  message?: string;
  className?: string;
  /**
   * Test ID for testing purposes
   * @default 'loading-screen'
   */
  testId?: string;
}

/**
 * LoadingScreen - Full screen loading indicator with optional message
 * 
 * Accessible loading state that announces to screen readers.
 * 
 * @example
 * ```tsx
 * <LoadingScreen message="Carregando dados..." />
 * ```
 */
export function LoadingScreen({ 
  message = 'Carregando...', 
  className,
  testId = 'loading-screen'
}: LoadingScreenProps) {
  return (
    <div
      className={cn(
        'flex min-h-[400px] flex-col items-center justify-center gap-4',
        className
      )}
      data-testid={testId}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 
        className="h-8 w-8 animate-spin text-primary" 
        aria-hidden="true"
      />
      <p className="text-muted-foreground" data-testid={`${testId}-message`}>
        {message}
      </p>
      {/* Screen reader only text */}
      <span className="sr-only">{message}</span>
    </div>
  );
}
